import React, { useCallback } from 'react';
import find from 'lodash/find';
import get from 'lodash/get';
import styled from 'styled-components';
import set from 'lodash/set';
import { InputField } from 'src/presentation/components/agent_desktop_components';
import { FieldWrapper } from '@ad-scripts/presentation/components/common/input_field';
import { ErrorLabel } from '@ad-scripts/presentation/components/common/forms/control_container';

type InputWithPrefixProps = {
  attr: string;
  autoFocus: boolean;
  formContext: any;
  placeholder: string;
  prefix: string;
};

const InputWithPrefix = ({ attr, autoFocus, formContext, placeholder, prefix }: InputWithPrefixProps) => {
  const { errors, workingState, updateState, resetError } = formContext;
  const error = find(errors, error => error.attr === attr);

  const onChange = useCallback(
    val => {
      resetError({ attr, errors });
      updateState(set({}, attr, val));
    },
    [attr, errors, resetError, updateState]
  );
  const v = `${get(workingState, attr)}`;
  return (
    <StyledWrapper>
      <StyledPrefix>{prefix}</StyledPrefix>
      <InputField autoFocus={autoFocus} data-aid={attr} placeholder={placeholder} onChange={onChange} value={v} />
      {error && <ErrorLabel data-aid={`${attr}-error`}>{error.detail}</ErrorLabel>}
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #e3e3e3;

  ${FieldWrapper} {
    border: none;
  }
`;

const StyledPrefix = styled.span`
  background-color: ${p => p.theme.colors.gray100};
  padding: 11px 13px;
`;

export default InputWithPrefix;
